import { useMutation, useQueryClient } from "@tanstack/react-query";
import { restoreAllJobTitles as apiRestoreAll } from "../../api/apiJobTitles";
import { useSnackbar } from "notistack";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useRestoreAllJobTitles() {
    const queryClient = useQueryClient();
    const { enqueueSnackbar } = useSnackbar();

    const { mutate: restoreAllJobTitles, isPending: isRestore } = useMutation({
        mutationFn: (req) => apiRestoreAll(req),
        onSuccess: (response) => {
            enqueueSnackbar(response.message, { variant: "success" });
            queryClient.invalidateQueries({ queryKey: ["jobTitles"] });
        },
        onError: (err) => {
            const msg = getErrorMessageFromAxiosError(err, "Something went wrong!");
            enqueueSnackbar(msg, { variant: "error" });
        },
    });

    return { restoreAllJobTitles, isRestore };
}
